export function DrawerLeaf({ size = 14 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M11 20A7 7 0 0 1 4 13c0-3.31 2-7 7-9 5 2 7 5.69 7 9a7 7 0 0 1-7 7z"
        stroke="currentColor"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11 20v-9" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" />
    </svg>
  );
}
